import React from 'react';
import { ColorPicker, Form } from 'antd';

const labelSpan = (t) => <span style={{ fontFamily: 'CustomFont' }}>{t}</span>;

/**
 * فیلد رنگ با ColorPicker آنت — مقدار hex برای API
 */
const WorkColorPickerField = ({ name, label, rules, required }) => (
  <Form.Item
    name={name}
    label={label ? labelSpan(label) : null}
    rules={rules}
    required={required}
    getValueFromEvent={(color) => {
      if (!color) return undefined;
      if (typeof color === 'string') return color;
      return color.toHexString?.() || color;
    }}
  >
    <ColorPicker showText format="hex" style={{ fontFamily: 'CustomFont' }} />
  </Form.Item>
);

export default WorkColorPickerField;
